<template>
  <div class="integrations">
    <div class="container">
      <h1 data-aos="fade" style="margin-bottom: 24px">INTEGRATIONS</h1>
      <BRow>
        <b-col lg="4" md="6" sm="12">
          <b-card data-aos="zoom-in" data-aos-duration="1000" class="card">
            <a href="https://help.fulfillin.com/mirakl" target="_blank">
              <img
                src="../../assets/images/integrations/linnworks.png"
                alt=""
              />
            </a>
          </b-card>
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <b-card data-aos="zoom-in" data-aos-duration="1000" class="card">
            <a href="https://help.fulfillin.com/veeqo" target="_blank">
              <img src="../../assets/images/integrations/veeqo.svg" alt="" />
            </a>
          </b-card>
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <b-card data-aos="zoom-in" data-aos-duration="1000" class="card">
            <a href="https://help.fulfillin.com/mirakl" target="_blank">
              <img src="../../assets/images/integrations/mirkal.png" alt="" />
            </a>
          </b-card>
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <b-card
            data-aos="zoom-in"
            data-aos-duration="1000"
            class="card coming-soon"
          >
            <div class="coming-soon-badge">Coming soon</div>
            <a
              class="coming-soon-link"
              role="button"
              tabindex="0"
              title="Coming soon"
              @click.prevent
            >
              <img src="../../assets/images/integrations/amazon.png" alt="" />
            </a>
          </b-card>
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <b-card
            data-aos="zoom-in"
            data-aos-duration="1000"
            class="card coming-soon"
          >
            <div class="coming-soon-badge">Coming soon</div>
            <a
              class="coming-soon-link"
              role="button"
              tabindex="0"
              title="Coming soon"
              @click.prevent
            >
              <img src="../../assets/images/integrations/shopify.png" alt="" />
            </a>
          </b-card>
        </b-col>
        <b-col lg="4" md="6" sm="12">
          <b-card
            data-aos="zoom-in"
            data-aos-duration="1000"
            class="card coming-soon"
          >
            <div class="coming-soon-badge">Coming soon</div>
            <a
              class="coming-soon-link"
              role="button"
              tabindex="0"
              title="Coming soon"
              @click.prevent
            >
              <img src="../../assets/images/integrations/walmart.png" alt="" />
            </a>
          </b-card>
        </b-col>
      </BRow>
    </div>
  </div>
</template>

<script>
import { BCol, BRow, BCard } from 'bootstrap-vue'

export default {
  name: 'Integrations',
  components: {
    BCol,
    BRow,
    BCard,
  },
}
</script>

<style lang="scss" scoped>
.integrations {
  background-color: #1b1c1e;

  .container {
    padding-bottom: 24px;
    padding-top: 24px;
    text-align: center;
  }

  .card {
    box-shadow: 0 0 30px black;
  }

  .card.coming-soon {
    position: relative;
  }

  .coming-soon-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
    background: rgba(0, 0, 0, 0.6);
    color: rgba(255, 255, 255, 0.9);
    font-size: 12px;
    letter-spacing: 0.06em;
    padding: 6px 10px;
    border-radius: 999px;
    text-transform: uppercase;
  }

  h1 {
    color: white;
    font-size: 48px;
    font-family: 'Open Sans', sans-serif;
    text-shadow: 0 0 20px black;
  }

  img {
    display: block;
    max-height: 100%;
    object-fit: contain;
    transform: scale(1);
    transition: 0.5s ease all;
    width: 70%;

    &:hover {
      transform: scale(1.1);
      transition: 0.5s ease all;
    }
  }

  .coming-soon-link {
    cursor: not-allowed;
  }

  .coming-soon-link img {
    filter: grayscale(1);
    opacity: 0.45;
  }

  .coming-soon-link img:hover {
    transform: scale(1);
  }
}

a {
  aspect-ratio: 16/10;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
